/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Prep_RoleplayInputs */



/**
* | output |
* | --- |
* | "Practice conversation" |
*
* @param {Chat_Quick_Prep_RoleplayInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_prep_roleplay = /** @type {((inputs?: Chat_Quick_Prep_RoleplayInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Prep_RoleplayInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefengesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversation d’entraînement")
	return /** @type {LocalizedString} */ ("Practice conversation")
});